import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon CabaretDuotone
 */
export const CabaretDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M128,45.6c29.4,0,53.3,23.9,53.3,53.3s-23.9,53.3-53.3,53.3s-53.3-23.9-53.3-53.3C74.7,69.5,98.6,45.6,128,45.6 M128,35.6 c-35,0-63.3,28.3-63.3,63.3S93,162.2,128,162.2s63.3-28.3,63.3-63.3C191.3,63.9,163,35.6,128,35.6L128,35.6z"
      fill="currentColor"
    />
    <path
      d="M227.3,86.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2C215,92.1,220.5,86.7,227.3,86.7  M227.3,76.7c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S239.5,76.7,227.3,76.7z"
      fill="currentColor"
    />
    <path
      d="M57.8,156.8c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3c0-3.2,1.3-6.4,3.6-8.6 C51.4,158.1,54.6,156.8,57.8,156.8 M57.8,146.8c-12.3,0-22.2,10-22.2,22.2c0,12.3,10,22.2,22.2,22.2s22.2-10,22.2-22.2 c0-5.9-2.3-11.6-6.5-15.7C69.4,149.2,63.7,146.8,57.8,146.8z"
      fill="currentColor"
    />
    <path
      d="M128,185.9c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.2c0,0,0,0,0,0 C115.8,191.4,121.2,185.9,128,185.9 M128,175.9c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3c12.3,0,22.3-10,22.3-22.2 c0,0,0,0,0,0C150.2,185.9,140.3,175.9,128,175.9z"
      fill="currentColor"
    />
    <path
      d="M198.2,156.8c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3c0-3.2,1.3-6.4,3.6-8.6 C191.8,158.1,194.9,156.8,198.2,156.8 M198.2,146.8c-12.3,0-22.2,10-22.2,22.2c0,12.3,10,22.2,22.2,22.2c12.3,0,22.2-10,22.2-22.2 c0-5.9-2.3-11.6-6.5-15.7C209.7,149.2,204.1,146.8,198.2,146.8z"
      fill="currentColor"
    />
    <path
      d="M28.7,86.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C16.5,92.1,22,86.7,28.7,86.7 M28.7,76.7c-12.3,0-22.3,10-22.3,22.2s10,22.2,22.2,22.2S51,111.2,51,98.9l0,0 C51,86.6,41,76.7,28.7,76.7z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M128,45.6c29.4,0,53.3,23.9,53.3,53.3s-23.9,53.3-53.3,53.3s-53.3-23.9-53.3-53.3C74.7,69.5,98.6,45.6,128,45.6 "
      fill="currentColor"
    />
    <path
      className="st0"
      d="M227.3,86.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2 C215,92.1,220.5,86.7,227.3,86.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M57.8,156.8c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3 c0-3.2,1.3-6.4,3.6-8.6C51.4,158.1,54.6,156.8,57.8,156.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M128,185.9c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.2c0,0,0,0,0,0 C115.8,191.4,121.2,185.9,128,185.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M198.2,156.8c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3 c0-3.2,1.3-6.4,3.6-8.6C191.8,158.1,194.9,156.8,198.2,156.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M28.7,86.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C16.5,92.1,22,86.7,28.7,86.7"
      fill="currentColor"
    />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default CabaretDuotone;
